export default {
  listEnglishTypingPassages: [
    {
      id: 1,
      name: "POPULATION",
      default: {
        passage: `Population is a very interesting topic to learn. There is no denying the fact that the population of any country is a very strong indicator of how exactly the country will function in the future and what its capabilities are as a nation. Leaders of the world pay a lot of attention to their country’s population for the same reason. The population and the skills that they possess are perhaps some of the most essential assets for any country. The following article is an essay on the topic of population and has been structured in a way that students of all ages can learn and understand the key points that they need to mention whenever they are writing an essay like this. 


      Brief on Population
      When we talk about a country’s population, we are talking about a lot of things. We are talking about its future workforce, the people that will build the country as a place to live and grow in, we definitely are talking about the future of the entire country. Taking India’s example, when we talk about the population of the country, we are talking about the future of the dream that our freedom fighters dreamt for us as a nation. Together, the entire population of a country has the potential to change the entire landscape of the kinds of work, and jobs that they do. 
      
       
      
      The population of a country is responsible for the economical changes and growth in the country and hence is very important. It is also very important to take care of this population. The population needs the right kind of food, healthy environment to grow in and a great and comfortable lifestyle right from the start. Is that something that is possible for everyone? We all know the answer to this. In a country like India, where income disparities are massive, there is no chance for every single section of the population to have a good lifestyle right from the start that can help them grow as individuals. 
      
       
      
      The same applies for other countries as well. Every country has an income disparity among the people that live in it and this is what makes the topic of population so interesting. We already know that it is the biggest asset that any country can have, but every country must plan and strategize well to take care of this population so that every single need is being fulfilled. This not only helps the country flourish as a whole, but also increases its chances of becoming successful in the future. 
      
       
      
      Population Explosion
      The current population of India is around 140 crores. According to certain reports, in the next few years, there will be a solid growth of population in India, and globally too.
      
       
      
      The population is the total number of human beings living in a city or the country. It allows knowing how much resources are required by this population to fulfil and other plans needed. Year by year, there has been an explosion of population, which is making it difficult to provide resources to every person living in the country. Low literacy, early marriage and demand for family growth are some of the reasons behind the explosion of the population.  India is the primary ground of population explosion. It covers 17% of the population of the world and is the most populated country.
      
       
      
      Reasons Behind the Growth of the Population
      There are many reasons for the growth of the population. The low literacy rate is one of the reasons behind this explosion. For example, in India, the literacy rate is relatively low in many states. Many people living in the village fail to complete education and have less knowledge about birth control. They keep on expanding their family.
      
       
      
      Moreover, they do not carry much knowledge about birth control techniques or medication. This lack of understanding further leads to a population explosion.
      
       
      
      Another primary reason behind the growth of population is child marriage. The custom of child marriage is still followed in many parts of the country. Parents marry off their daughter at an early age, and at a young age, these girls get pregnant. This process continues for a long time.
      
       
      
      One of the reasons behind this growth is there are not strict laws in India, unlike other countries. This also makes it hard for citizens to get an equal share of resources.
      
       
      
      Impact of Population Explosion
      Population explosion causes harm, not only to citizens of the country, but also nature. Increase in population means the need for more space to live, resulting in deforestation. Many cities have lost the green zone to fill it with urban living. Deforestation is leading to the extinction of species and other resources.  Animals are losing their homes, which makes them encroach on cities taking the lives of people.
      
       
      
      Subsequently, an increase in population is also leading to population. More and more people are buying vehicles for their convenience, which is resulting in pollution. Massive traffic, congestion on roads and other negative scenes are witnessed in cities.
      
       
      
      Population increase also calls for industrialization, which invites pollution in all areas. A country like India is now witnessing a massive problem of pollution and global warming.
      
       
      
      Irregular distribution of food to all populations is another significant impact. Many families in rural areas do not get proper food to eat. Many poor kids go to sleep without eating food. This irregular distribution of food is not the scenario only in India, but other developing countries.
      
       
      
      How to Control the Population?
      One of the ways to control the population is to educate people about its ill effects on the country's resources. Government, along with NGOs, need to visit every rural area of the country to inform people about population control.
      
       
      
      Providing birth control kits, education to kids and monetary benefits to families successful in restricting birth can do the needful.
      
       
      Conclusion`,
      },
    },
    {
      id: 2,
      name: "My Village",
      default: {
        passage: `A majority of the Indian population are farmers who are settled in villages. They toil to make both ends meet and produce crops for the entire nation. India has about 500000 villages, which are scattered throughout the country. A village is a settlement that has fewer than 5000 living units. A village is called the rural part of the country. It is called rural because it does not have modern facilities like cities. The main occupation of the villagers is farming. They are the primary source of the nation's agricultural production.`,
      },
    },
    {
      id: 3,
      name: "A figure of speech",
      default: {
        passage: `Figure of speech can easily catch eyes and highlight the purpose of use. It is designed to make a comparison and create a dramatic factor while writing or speaking. Basically, it is a figurative language that may consist of a single word or phrase. It may be a simile, a metaphor or personification to convey the meaning other than the literal meaning. It is usually classified as different schemes. The ordinary sequence or pattern of words is known as a scheme. We usually perform basic four operations as below to create the required effect.`,
      },
    },
  ],
  allTimeDuration: [
    { id: 1, name: "1 min" },
    { id: 5, name: "5 min" },
    { id: 10, name: "10 min" },
    { id: 15, name: "15 min" },
    { id: "free", name: "Free Time" },
  ],
  selectedTimeDuration: 10,
  allTypingWordsLength: [
    { id: 50, name: "50 Words Passage" },
    { id: 100, name: "100 Words Passage" },
    { id: 200, name: "200 Words Passage" },
    { id: 300, name: "300 Words Passage" },
    { id: 500, name: "500 Words Passage" },
    { id: 1000, name: "1000 Words Passage" },
  ],
  selectedTypingWordsLength: 100,
  isDisableBackSpace: false,
  totalCharacters: 200,
  // listTimeDuration: [
  //   { id: 1, name: "1 min" },
  //   { id: 5, name: "5 min" },
  //   { id: 10, name: "10 min" },
  //   { id: 15, name: "15 min" },
  //   { id: "free", name: "Free Time" },
  // ],
  selectedTimeDuration: "free",
  lessons: [
    { title: "Lesson 1", name: "f j" },
    { title: "Lesson 2", name: "d k" },
    { title: "Lesson 3", name: "f j d k" },
    { title: "Lesson 4", name: "s l" },
    { title: "Lesson 5", name: "a ;" },
    { title: "Lesson 6", name: "s l a ;" },
    { title: "Lesson 7", name: "g h '" },
    { title: "Lesson 8", name: "f j d k s l a ; g h '" },

    { title: "Lesson 9", name: "F J" },
    { title: "Lesson 10", name: "D K" },
    { title: "Lesson 11", name: "F J D K" },
    { title: "Lesson 12", name: "S L" },
    { title: "Lesson 13", name: "A :" },
    { title: "Lesson 14", name: "S L A :" },
    { title: "Lesson 15", name: 'G H "' },
    { title: "Lesson 16", name: 'F J D K S L A ; G H "' },

    { title: "Lesson 17", name: "r u" },
    { title: "Lesson 18", name: "e i" },
    { title: "Lesson 19", name: "r u e i" },
    { title: "Lesson 20", name: "w o" },
    { title: "Lesson 21", name: "q p" },
    { title: "Lesson 22", name: "w o q p" },
    { title: "Lesson 23", name: "t [" },
    { title: "Lesson 24", name: "y ]" },
    { title: "Lesson 25", name: "t [ y ]" },
    { title: "Lesson 26", name: "r u e i w o q p t [ y ]" },

    { title: "Lesson 27", name: "R U" },
    { title: "Lesson 28", name: "E I" },
    { title: "Lesson 29", name: "R U E I" },
    { title: "Lesson 30", name: "W O" },
    { title: "Lesson 31", name: "Q P" },
    { title: "Lesson 32", name: "W O Q P" },
    { title: "Lesson 33", name: "T {" },
    { title: "Lesson 34", name: "Y }" },
    { title: "Lesson 35", name: "T { Y }" },
    { title: "Lesson 36", name: "R U E I W O Q P T { Y }" },

    { title: "Lesson 37", name: "v m" },
    { title: "Lesson 38", name: "c ," },
    { title: "Lesson 39", name: "v m c ," },
    { title: "Lesson 40", name: "x ." },
    { title: "Lesson 41", name: "z /" },
    { title: "Lesson 42", name: "x . z /" },
    { title: "Lesson 43", name: "b n" },
    { title: "Lesson 44", name: "v m c , x . z / b n" },

    { title: "Lesson 45", name: "V M" },
    { title: "Lesson 46", name: "C <" },
    { title: "Lesson 47", name: "V M C <" },
    { title: "Lesson 48", name: "X >" },
    { title: "Lesson 49", name: "Z ?" },
    { title: "Lesson 50", name: "X > Z ?" },
    { title: "Lesson 51", name: "B N" },
    { title: "Lesson 52", name: "V M C < X > Z ? B N" },
  ],
};
